import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { $qs, $qsa } from "../utils/QuerySelector";
import { media } from "../utils/MediaQueries";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

const videoTeaser = $qs(".block--video-grow");
const videoCursor = $qs(".custom-cursor");

function setInitialCursorPosition(videoTeaser) {
  const cursor = $qs(".custom-cursor", videoTeaser);

  cursor.style.transform =
    "translate3d(${videoTeaser.offsetWidth / 2}px, ${videoTeaser.offsetHeight / 2}px, 0)";
}

function handleMouseMove(e) {
  const cursor = $qs(".custom-cursor", this);
  const body = $qs("body");
  const { pageX, pageY } = e;
  const x = e.clientX;
  const y = e.clientY;

  gsap.to(cursor, {
    x: x,
    y: y,
    position: "fixed",
    duration: 0.5,
  });

  // body.style.cursor = 'none';
}

function handleMouseLeave(e) {
  const cursor = $qs(".custom-cursor", this);
  const body = $qs("body");
  const x = videoTeaser.offsetWidth / 2;
  const y = videoTeaser.offsetHeight / 2;

  gsap.to(cursor, {
    x: x,
    y: y,
    duration: 1,
    position: "absolute",
    ease: "power3.out",
  });

  // body.style.cursor = 'auto';
}

function videoOnScroll(e) {
  //const x = e.clientX;
  const y = e.clientY;
  console.log(y);

  const videoTeaser = $qs(".block--video-grow");
  const offset = videoTeaser.offset();
  const top = offset.top;
  console.log(top);
  const bottom = top - height;
  const height = videoTeaser.height();

  if (y > top && y < bottom) {
    handleMouseMove();
  } else {
    handleMouseLeave();
  }
}

function VideoCursor() {
  const jsVideoGrow = $qs(".js-video-grow");

  //if (!videoTeaser) return;
  if (!videoCursor) return;

  setInitialCursorPosition(videoTeaser);
  window.addEventListener("load", () => setInitialCursorPosition(videoTeaser));

  if (media.md) return;

  videoTeaser.addEventListener("pointermove", handleMouseMove);
  videoTeaser.addEventListener("wheel", handleMouseLeave);
  videoTeaser.addEventListener("pointerleave", handleMouseLeave);

  //videoTeaser.addEventListener('scroll', videoOnScroll);
}

const growVideo = () => {
  if (media.md) return;

  const growVideo = gsap.timeline({ paused: true });
  const moveFloatingImages = gsap.timeline({ paused: true });

  let blockVideoGrow = $(".block--video-grow");
  let videoTeaser = $(".js-video-grow .video-teaser");
  let videoEnd = $(".grow-video-end");
  let imgOneX = 0;
  let imgTwoX = 0;

  let floatingImgOne = $(".block--video-grow .floating-img--1");
  let floatingImgTwo = $(".block--video-grow .floating-img--2");

  growVideo.to(".js-video-grow .video-teaser", {
    scale: 1.03,
    duration: 3,
  });
  growVideo.to(
    ".custom-cursor",
    {
      opacity: 1,
      duration: 2,
    },
    "<+4"
  );

  if ($qs("body.page-template-tpl-home")) {
    imgOneX = -170;
    imgTwoX = 180;
  } else {
    imgOneX = -240;
    imgTwoX = 230;
  }
  moveFloatingImages.to(floatingImgOne, {
    rotate: 18,
    xPercent: imgOneX,
    duration: 1.2,
    //ease: "power2.inOut"
    ease: "none",
  });
  moveFloatingImages.to(
    floatingImgTwo,
    {
      rotate: -18,
      xPercent: imgTwoX,
      duration: 1.2,
      //ease: "power2.inOut"
      ease: "none",
    },
    "<"
  );

  // Move side images out of the way
  ScrollTrigger.create({
    trigger: blockVideoGrow,
    start: "top 40%",
    end: "80% 10%",
    scrub: 0.6,
    animation: moveFloatingImages,
  });

  // Scale video teaser
  ScrollTrigger.create({
    trigger: blockVideoGrow,
    start: "top 20%",
    end: "15% top",
    scrub: 0.6,
    animation: growVideo,
  });

  // Pin video teaser
  ScrollTrigger.create({
    trigger: videoTeaser,
    endTrigger: videoEnd,
    start: "top -1%",
    end: "bottom bottom",
    scrub: 0.6,
    pin: videoTeaser,
  });

  VideoCursor();
};

export default growVideo;
